'use client';

import './globals.css';
import { RuntimeFailureBoundary } from '@/components/runtime-failure/runtime-failure-boundary';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <html lang="ru" className="overflow-x-hidden">
            <body className="antialiased">
                <RuntimeFailureBoundary error={error} reset={reset} boundary="global" />
            </body>
        </html>
    );
}
